import { render, staticRenderFns } from "./CustomPayment-60-Realshield.vue?vue&type=template&id=63aed0a9&scoped=true&"
import script from "./CustomPayment-60-Realshield.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-60-Realshield.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-60-Realshield.vue?vue&type=style&index=0&id=63aed0a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aed0a9",
  null
  
)

export default component.exports